var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page light f-col-ac"},[_c('div',{staticClass:"f-grow"}),_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/text_logo.svg")}}),_c('h1',[_vm._v("Server Error!")]),_c('img',{staticClass:"image",attrs:{"src":require("@/assets/server_error.svg")}}),_c('div',{staticClass:"f-grow"}),_c('div',{staticClass:"f-grow"})])
}]

export { render, staticRenderFns }